<template>
  <v-btn :color="inNetwork ? 'grey lighten-4' : 'primary'" @click="onClick" x-small>
    {{ inNetwork ? 'Block from Network' : 'Add to Network'}}
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'
import proMixin from '../proMixin'

export default {
  name: 'InNetworkButton',
  
  mixins: [ proMixin ],

  props: ['pro'],

  computed: {
    inNetwork() {
      return this.isPartner(this.pro)
    },
  },

  methods: {
    ...mapActions('pros', ['toggleCurrentPartnershipStatus']),

    onClick() {
      this.toggleCurrentPartnershipStatus()
    }
  }
}
</script>